var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"aboutme"}},[_vm._m(0),_c('div',{staticClass:"main"},[_c('div',{staticClass:"comp"},[_c('h1',[_vm._v("关于道可维斯")]),_c('div',{staticClass:"info editor-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topImg"},[_c('img',{staticClass:"banner_phone",attrs:{"src":require("../../assets/images/aboutmepc.png"),"alt":"关于我们"}})])
}]

export { render, staticRenderFns }